import React from 'react'
import Button from '@components/UI/Button'

export default function StepFourCaptchaSubmit({ step, errorFields, captchaRef }) {
  return (
    <div className={`${step !== 3 ? 'hidden' : 'block'} md:block`}>
      <div ref={captchaRef} className="mb-4" />
      <input type="hidden" name="cf-turnstile-response" />
      <div className="text-right">
        <Button type="submit" size="lg">
          Submit Event
        </Button>
      </div>
    </div>
  )
}